import { isSameDay, set } from 'date-fns'
import { Parse, Format } from './datesFormat'
import fr from 'date-fns/locale/fr/index.js'

const setTime = (date: Date, time: string): Date => {
  const [hours, minutes] = time.split(':').map(unit => parseInt(unit))
  return set(date, { hours, minutes })
}

const getLocale = (lang: string): Locale | null => (lang === 'en' ? null : fr)

const isPartialDate = (start: string | Date, end: string | Date): boolean => {
  return Format(start, { outFormat: 'timeFull' }) !== '00:00:00' && Format(end, { outFormat: 'timeFull' }) !== '23:59:59'
}

type GenerateDateTextType = (
  start: string | Date,
  end: string | Date,
  options?: { partialOnlyTime?: boolean; standardTimeDateDisplay?: boolean; currentLang?: 'fr' | 'en' }
) => string
const generateDateText: GenerateDateTextType = (start, end, { partialOnlyTime, standardTimeDateDisplay, currentLang } = {}) => {
  start = Parse(start)
  end = Parse(end)
  const sameDay = isSameDay(start, end)
  const partialDate = isPartialDate(start, end)

  const startDate = Format(start, { outFormat: 'humanDate', standardTimeDateDisplay, currentLang })
  const startTime = Format(start, { outFormat: 'time', standardTimeDateDisplay, currentLang })
  const endDate = Format(end, { outFormat: 'humanDate', standardTimeDateDisplay, currentLang })
  const endTime = Format(end, { outFormat: 'time', standardTimeDateDisplay, currentLang })

  if (!partialDate) {
    if (!sameDay) return `${startDate} - ${endDate}`
    else return `${startDate}`
  } else {
    if (partialOnlyTime) return `${startTime} - ${endTime}`
    else if (!sameDay) return `${startDate} (${startTime}) - ${endDate} (${endTime})`
    else return `${startDate} (${startTime} - ${endTime})`
  }
}

export { generateDateText, isPartialDate, setTime, getLocale }
